import type { CSSProperties } from 'react';

export const styles: { [key: string]: CSSProperties } = {
  floatingTextFormatPopup: {
    display: 'flex',
    background: '#fff',
    padding: 4,
    verticalAlign: 'middle',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10,
    opacity: 0,
    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.3)',
    borderRadius: 8,
    transition: 'opacity 0.5s',
    height: 35,
    willChange: 'transform',
  },
  popupItem: {
    border: 0,
    display: 'flex',
    background: 'none',
    borderRadius: 10,
    padding: 8,
    cursor: 'pointer',
    verticalAlign: 'middle',
    alignItems: 'center',
  },
  popupItemDisabled: {
    cursor: 'not-allowed',
    opacity: 0.2,
  },
  popupItemSpaced: {
    marginRight: 2,
  },
  formatIcon: {
    backgroundSize: 'contain',
    height: 18,
    width: 18,
    marginTop: 2,
    verticalAlign: '-0.25em',
    display: 'flex',
    opacity: 0.6,
  },
  activePopupItem: {
    backgroundColor: 'rgba(223, 232, 250, 0.3)',
  },
  activeFormatIcon: {
    opacity: 1,
  },
  popupItemHover: {
    backgroundColor: '#eee',
  },
  selectPopupItem: {
    border: 0,
    display: 'flex',
    background: 'none',
    borderRadius: 10,
    padding: 8,
    verticalAlign: 'middle',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    width: 70,
    fontSize: 14,
    color: '#777',
    textOverflow: 'ellipsis',
  },
  codeLanguage: {
    textTransform: 'capitalize',
    width: 130,
  },
  text: {
    display: 'flex',
    lineHeight: '20px',
    verticalAlign: 'middle',
    fontSize: 14,
    color: '#777',
    textOverflow: 'ellipsis',
    width: 70,
    overflow: 'hidden',
    height: 20,
    textAlign: 'left',
  },
  icon: {
    display: 'flex',
    width: 20,
    height: 20,
    userSelect: 'none',
    marginRight: 8,
    lineHeight: '16px',
    backgroundSize: 'contain',
  },
  chevronDown: {
    marginTop: 3,
    width: 16,
    height: 16,
    display: 'flex',
    userSelect: 'none',
  },
  chevronDownInside: {
    width: 16,
    height: 16,
    display: 'flex',
    marginLeft: -25,
    marginTop: 11,
    marginRight: 10,
    pointerEvents: 'none',
  },
  divider: {
    width: 1,
    backgroundColor: '#eee',
    margin: '0 4px',
  },
} as const;
